import { combineReducers } from "redux";
import * as HomePageReducer from "src/Components/HomePage/Redux/Reducer";

export const combinedReducers = combineReducers({
  ...HomePageReducer,
});
